import React from 'react';
import { useAppUI } from '../../hooks/useAppUI';
import Toast from './Toast';

/**
 * Container component that renders all active toasts
 * Should be placed at the root level of the app
 */
const ToastContainer: React.FC = () => {
  const { toasts, removeToast, executeToastAction } = useAppUI();

  const handleToastClose = (id: string) => {
    removeToast(id);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleToastAction = (id: string, callbackId?: string) => {
    if (callbackId) {
      executeToastAction(callbackId);
    }
    removeToast(id);
  };
  
  return (
    <>
      {Object.values(toasts).map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.autoClose ? toast.duration : 0}
          position="bottom-center"
          onClose={() => handleToastClose(toast.id)}
          showClose={true}
        />
      ))}
    </>
  );
};

export default ToastContainer;